import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'

import {
  doFetchCurrentConversationContact,
  selectCurrentContactIdOrCustomerId,
} from 'ducks/crm/contacts'
import { doFetchAllCustomFields } from 'ducks/crm/customFields'
import { doFetchAllCustomFieldCategories } from 'ducks/crm/customFieldCategories'
import { selectCurrentCustomerId } from 'selectors/tickets'
import { Loader } from 'shared/ui'
import { useActionEffect } from 'util/hooks'

import {
  selectIsContactDetailsColumnLoaded,
  selectIsContactDetailsColumnLoading,
} from './selectors'
import WidgetCards from './WidgetCards'

export default function ContactDetailsColumn() {
  const contactId = useSelector(selectCurrentContactIdOrCustomerId)
  const customerId = useSelector(selectCurrentCustomerId)
  const isLoaded = useSelector(selectIsContactDetailsColumnLoaded)
  const isLoading = useSelector(selectIsContactDetailsColumnLoading)
  useActionEffect(doFetchAllCustomFields, [])
  useActionEffect(doFetchAllCustomFieldCategories, [])
  useActionEffect(doFetchCurrentConversationContact, [customerId])

  if (!contactId) return null

  return (
    <Fragment>
      {!isLoaded && isLoading && <Loader mt={10} />}
      {isLoaded && <WidgetCards key={contactId} />}
    </Fragment>
  )
}
